
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lib/podcasts/[id]",
      function () {
        return require("private-next-pages/lib/podcasts/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lib/podcasts/[id]"])
      });
    }
  